export function isValidAppyId(id: string): boolean {
  return /^[0-9A-Za-z\-_.~]{22}$/.test(id);
}
